import * as React from 'react'

import { useFeatureFlags } from '@app/domain/feature-flags/feature-flags.hooks'

interface ComponentProps {
  feature: string
  children: React.ReactNode
}

export const RequireFeatureFlag = function ({
  feature,
  children,
}: ComponentProps) {
  const featureFlags = useFeatureFlags()

  return (
    <React.Fragment>
      {featureFlags.isFeatureFlagEnabled(feature) ? children : null}
    </React.Fragment>
  )
}
